import { DATES, DATES_ID } from 'services/constants/dates-constants';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TPartnerReport } from 'redux/reducers/referrals/types';

export const DOWNLOAD_ACTION = 'Download';

export const PARTNER_FILTER_SELECTOR = 'partnerId';

/** The first year the partner reports exist for, the year filter starts from it. */
export const FIRST_REPORT_YEAR = 2025;

export const MONTHS = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

/** The Partner and Year options are filled in at runtime, see `withFilterOptions`. */
export const tableStructure: TTableStructure<keyof TPartnerReport, TPartnerReport>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Partner',
		selector: PARTNER_FILTER_SELECTOR,
		value: (item: TPartnerReport) => item.partnerName ?? String(item.partnerId),
		show: true,
		separateFilter: true,
		separateFilterAutocomplete: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		filter: [],
	},
	{
		name: 'Year',
		selector: 'year',
		show: true,
		separateFilter: true,
		colSpan: 1,
		type: ETableStructureType.STATUS_NO_BG,
		align: ETableStructureAlign.LEFT,
		filter: [],
	},
	{
		name: 'Month',
		selector: 'month',
		show: true,
		separateFilter: false,
		colSpan: 1,
		type: ETableStructureType.STATUS_NO_BG,
		align: ETableStructureAlign.LEFT,
		filter: MONTHS.map((month, index): [string, string] => [String(index + 1), month]),
	},
	{
		name: 'Created At',
		selector: 'createdAt',
		show: true,
		sortable: false,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],
	},
	{
		name: 'Actions',
		noName: true,
		selector: 'actions',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [{ name: DOWNLOAD_ACTION, icon: EIconButtons.DOWNLOAD }],
	},
];
